module.exports = __webpack_public_path__ + "img/p1.09842dff.png";